let glob = import.meta.glob("../../Pages/**/ClientDocumentsList.svelte");

/** @type {import("@intellectability/platform-common/router").RouterConfig} */
const routerConfig = {
    spa: false,
    appPath: "index.php",
    routes: [
        // This stitch is the one that isn't served from index.php — it is hosted by the
        // legacy client_documents.php page. appPath stays "index.php" so links (the Home
        // breadcrumb) resolve against the app stub, which means the router sees the
        // current path as "client_documents.php" and needs a route that matches it.
        // The "/" route is what matches under the dev server, where the path is empty.
        {
            layout: "null",
            path: "/",
            render: getComponent(glob),
            title: process.env.VITE_PAGE_TITLE,
            secure: false,
        },
        {
            layout: "null",
            path: "client_documents.php",
            render: getComponent(glob),
            title: process.env.VITE_PAGE_TITLE,
            secure: false,
        }
    ]
};

export default routerConfig;

/**
 * Find the component to render based on the name
 * @param {Record<string, () => Promise<unknown>>} glob
 * @returns {import("@intellectability/platform-common/router").LazyComponent}
 */
function getComponent(glob) {
    let key = Object.keys(glob)[0];
    if (key) {
        const loader = glob[key + ""];
        return /** @type {import("@intellectability/platform-common/router").LazyComponent} */ (loader);
    }
    return () => import("../../Pages/Core/Security/Errors/NotFound.svelte");
}